module.exports = __webpack_public_path__ + "media/npc_dota_hero_enigma.aef2ece2.webm";